export default "__VITE_ASSET__adb5776d__"